import {useSelector} from "react-redux";

import "./style.scss";

const Notice = () => {
    const notice = useSelector(state => state.UI.general?.notice);

    if (!notice) {
        return;
    }

    return (
        <div className="notice mt-2">
                {notice}
        </div>
    );
}

export default Notice;